<template>
    <div class="bg-white shadow rounded-lg divide-y divide-gray-200" :class="{ 'overflow-hidden': overflowHidden }">
        <div class="px-4 py-5 sm:px-6" v-if="$slots.title">
            <slot name="title" />
        </div>
        <div class="px-4 py-5 sm:p-6">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardPanel',
    props: {
        overflowHidden: {
            required: false,
            default: true,
            type: Boolean,
        },
    },
};
</script>
